/**
 * Initializes the behavior for Mixed Checkbox fields (Koble).
 * Handles updating hidden inputs when individual taxonomy checkboxes are toggled.
 */
export default function initCheckboxMixed() {
    const wrappers = document.querySelectorAll('.checkbox-mixed-wrapper');

    wrappers.forEach(wrapper => {
        const checkboxes = wrapper.querySelectorAll('.mixed-checkbox-item');

        checkboxes.forEach(cb => {
            cb.addEventListener('change', function() {
                const tax = this.getAttribute('data-taxonomy');
                updateHiddenInput(wrapper, tax);
            });
        });
    });
}

/**
 * Updates the hidden input value for a specific taxonomy within a wrapper.
 * @param {HTMLElement} wrapper 
 * @param {string} taxonomy 
 */
function updateHiddenInput(wrapper, taxonomy) {
    const hiddenInput = wrapper.querySelector('#mixed-field-' + taxonomy);
    const relevantCheckboxes = wrapper.querySelectorAll('.mixed-checkbox-item[data-taxonomy="' + taxonomy + '"]:checked');
    
    const values = [];
    relevantCheckboxes.forEach(item => {
        values.push(item.getAttribute('data-value'));
    });
    
    if (hiddenInput) {
        hiddenInput.value = values.join(',');
    }
}
